export const isBrowser = (): boolean => {
  try {
    return typeof window === "object";
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return false;
  }
};
